@if (visible()) {
  <div class="rag-chat-panel" [class.rag-chat-panel--expanded]="expanded()">
    <header barDesign="header" class="rag-chat-header" fd-bar>
      <div fd-bar-left>
        <fd-bar-element>
          <h1 fd-title [headerSize]="5">Hyperspace RAG</h1>
        </fd-bar-element>
      </div>
      <div fd-bar-right>
        <fd-bar-element>
          <button
            ariaLabel="Toggle size"
            fd-button
            fdType="transparent"
            [glyph]="expanded() ? 'collapse' : 'expand'"
            (click)="toggleExpand()"
          ></button>
        </fd-bar-element>
        <fd-bar-element>
          <button
            ariaLabel="Close"
            fd-button
            fdType="transparent"
            glyph="decline"
            (click)="close()"
          ></button>
        </fd-bar-element>
      </div>
    </header>

    <div
      #messagesContainer
      class="rag-chat-messages"
      fd-scrollbar
      [noHorizontalScroll]="true"
    >
      @for (msg of messages(); track $index) {
        <div
          class="rag-chat-msg"
          [class.rag-chat-msg--assistant]="msg.role === 'assistant'"
          [class.rag-chat-msg--user]="msg.role === 'user'"
        >
          @if (msg.role === 'user') {
            <div class="rag-chat-msg__bubble rag-chat-msg__bubble--user">
              {{ msg.content }}
            </div>
          } @else {
            <div class="rag-chat-msg__bubble rag-chat-msg__bubble--assistant">
              @if (msg.sources && msg.sources.length > 0) {
                <details class="rag-chat-sources">
                  <summary>Used {{ msg.sources.length }} sources</summary>
                  <ul>
                    @for (source of msg.sources; track source.rank) {
                      <li>
                        <span class="rag-chat-sources__name">{{
                          source.source
                        }}</span>
                        @if (source.score !== null) {
                          <span class="rag-chat-sources__score"
                            >{{ source.score * 100 | number: '1.0-0' }}%</span
                          >
                        }
                      </li>
                    }
                  </ul>
                </details>
              }

              @if (msg.loading) {
                <fd-busy-indicator size="s" [loading]="true" />
              } @else {
                <markdown class="rag-chat-msg__text" [data]="msg.content" />
              }
            </div>
          }
        </div>
      } @empty {
        <div class="rag-chat-welcome">
          <div class="rag-chat-welcome__icon">
            <fd-icon glyph="ai" />
          </div>
          <h3>Hello!</h3>
          <p>Ask me anything about Hyperspace documentation.</p>
        </div>
      }
    </div>

    <div class="rag-chat-input">
      <div class="rag-chat-input__box">
        <textarea
          #textarea
          class="rag-chat-input__textarea"
          name="rag-chat-input"
          placeholder="Ask about Hyperspace docs..."
          rows="1"
          [disabled]="isStreaming()"
          [value]="inputText()"
          (input)="onInputChange($event)"
          (keydown)="onKeydown($event)"
        ></textarea>
        <div class="rag-chat-input__actions">
          <div class="rag-chat-scope">
            @if (scopeMenuOpen()) {
              <div
                class="rag-chat-scope__backdrop"
                (click)="scopeMenuOpen.set(false)"
              ></div>
              <div class="rag-chat-scope__menu">
                @for (option of scopeOptions; track option.value) {
                  <button
                    class="rag-chat-scope__option"
                    [class.rag-chat-scope__option--active]="
                      scope() === option.value
                    "
                    (click)="setScope(option.value)"
                  >
                    <fd-icon
                      class="rag-chat-scope__check"
                      glyph="accept"
                      [class.rag-chat-scope__check--hidden]="
                        scope() !== option.value
                      "
                    />
                    <span>
                      <strong>{{ option.label }}</strong>
                      <small>{{ option.description }}</small>
                    </span>
                  </button>
                }
              </div>
            }
            <button class="rag-chat-scope__pill" (click)="toggleScopeMenu()">
              {{ scopeLabel() }}
              <fd-icon glyph="slim-arrow-down" />
            </button>
          </div>
          <button
            class="rag-chat-input__send"
            [disabled]="!inputText().trim() || isStreaming()"
            (click)="send()"
          >
            <fd-icon glyph="paper-plane" />
          </button>
        </div>
      </div>
    </div>
  </div>
}
